import ZipCodeLocator from 'components/ProductPage/Type/DigitalProduct/SameDayUnlimitedLandingPage/ZipCodeLocator/ZipCodeLocator';
import { withZipCodeLocatorProps } from 'viewModel/productPage/type/digitalProduct/sameDayUnlimitedLandingPage/zipCodeLocator/withZipCodeLocatorProps';

export default withZipCodeLocatorProps(ZipCodeLocator);
